import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL || '';
export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

export function backendHost() {
  return BACKEND;
}

export function mediaUrl(mediaId) {
  return `${API_BASE}/media/${mediaId}/file`;
}

export function thumbUrl(mediaId) {
  return `${API_BASE}/media/${mediaId}/thumb`;
}

export function wsUrl(path) {
  const url = new URL(BACKEND);
  const proto = url.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${url.host}/api${path}`;
}
